var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34187 13.501C5.47828 13.6374 5.66333 13.714 5.85623 13.714C6.04917 13.714 6.23417 13.6374 6.37053 13.501L16.2869 3.58463C16.4234 3.44822 16.5 3.26323 16.5 3.07033C16.5 2.87738 16.4234 2.69239 16.2869 2.55598L14.2296 0.498674C13.9455 0.214659 13.485 0.21461 13.2009 0.498674L5.85642 7.84326L3.79902 5.78586C3.66261 5.64945 3.47757 5.57279 3.28467 5.57279C3.09177 5.57279 2.90677 5.64945 2.77036 5.78586L0.713012 7.84321C0.428996 8.12728 0.428996 8.5878 0.713012 8.87187L5.34187 13.501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepComplete);
export default __webpack_public_path__ + "static/media/step-complete.383033d57c13afcfb1406f53c8680290.svg";
export { ForwardRef as ReactComponent };